/* eslint-disable react/jsx-pascal-case */
import React, { Fragment, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { userRoles, ScrollToTop, getCurrentLocale, RoutesListener, closeMenu, trackPageView } from "@awe-web/shared/lib";
import { Translation as T } from "@awe-web/shared/lib";
import { getUserRole } from "../../user/store.js";

import { Screen, ScreenHeader, ScreenFooter } from "../../components/screen.js";
import { SidebarMenu } from "../../components/sidebar_menu.jsx";
import { FullScreenLoadingIndicator } from "../../components/loading_indicator.jsx";

// B2C Long term reservation process
import B2C_LTR_SelectRentObject from "../../screens/b2c_long_term_reservation/select_rent_object/select_rent_object.jsx";
import B2C_LTR_SelectExtras from "../../screens/b2c_long_term_reservation/select_extras/select_extras.jsx";
import B2C_LTR_SelectProvisioning from "../../screens/b2c_long_term_reservation/select_provisioning/select_provisioning.jsx";
import B2C_LTR_SubmitRentContract from "../../screens/b2c_long_term_reservation/submit_rent_contract/submit_rent_contract.jsx";
import B2C_LTR_SubmitRentContractSuccess from "../../screens/b2c_long_term_reservation/submit_rent_contract_success/submit_rent_contract_success.jsx";

// B2C Short term reservation process
import B2C_ReservationEntry from "../../screens/reservation_entry/reservation_entry.jsx";
import B2C_SelectStationAndTime from "../../screens/b2c_short_term_reservation/select_station_and_time/select_station_and_time.jsx";
import B2C_STR_SelectRentObject from "../../screens/b2c_short_term_reservation/select_rent_object/select_rent_object.jsx";
import B2C_STR_SelectExtras from "../../screens/b2c_short_term_reservation/select_extras/select_extras.jsx";
import B2C_STR_SubmitRentContract from "../../screens/b2c_short_term_reservation/submit_rent_contract/submit_rent_contract.jsx";
import B2C_STR_SubmitRentContractSuccess from "../../screens/b2c_short_term_reservation/submit_rent_contract_success/submit_rent_contract_success.jsx";

// B2B Long term reservation process
import B2B_SelectStationAndTime from "../../screens/b2b_select_station_and_time/select_station_and_time.jsx";
import B2B_LTR_SelectRentObject from "../../screens/b2b_long_term_reservation/select_rent_object/select_rent_object.jsx";
import B2B_LTR_SelectExtras from "../../screens/b2b_long_term_reservation/select_extras/select_extras.jsx";
import B2B_LTR_SelectDriverAndProvisioning from "../../screens/b2b_long_term_reservation/select_driver_and_provisioning/select_driver_and_provisioning.jsx";
import B2B_LTR_SubmitRentContract from "../../screens/b2b_long_term_reservation/submit_rent_contract/submit_rent_contract.jsx";
import B2B_LTR_SubmitRentContractSuccess from "../../screens/b2b_long_term_reservation/submit_rent_contract_success/submit_rent_contract_success.jsx";

// B2B Short term reservation process
import B2B_STR_SelectRentObject from "../../screens/b2b_short_term_reservation/select_rent_object/select_rent_object.jsx";
import B2B_STR_SelectExtras from "../../screens/b2b_short_term_reservation/select_extras/select_extras.jsx";
import B2B_STR_SelectDriverComponent from "../../screens/b2b_short_term_reservation/select_driver/select_driver.jsx";
import B2bStrSubmitRentContractComponent from "../../screens/b2b_short_term_reservation/submit_rent_contract/submit_rent_contract.jsx";
import B2B_STR_SubmitRentContractSuccess from "../../screens/b2b_short_term_reservation/submit_rent_contract_success/submit_rent_contract_success.jsx";

// B2C Sign up
import B2C_SignUp from "../../screens/b2c_user/sign_up/sign_up.jsx";
import B2C_SignUpSuccess from "../../screens/b2c_user/sign_up_success/sign_up_success.jsx";
import B2C_ConfirmSignUpEntry from "../../screens/b2c_user/confirm_sign_up_entry/confirm_sign_up_entry.jsx";
import B2C_SignUpConfirmed from "../../screens/b2c_user/sign_up_confirmed/sign_up_confirmed.jsx";
import B2C_SignUpExtended from "../../screens/b2c_user/sign_up_extended/sign_up_extended.jsx";

// B2B Sign up
import B2B_SignUpRequest from "../../screens/b2b_user/sign_up_request/sign_up_request.jsx";
import B2B_SignUpRequestSuccess from "../../screens/b2b_user/sign_up_request_success/sign_up_request_success.jsx";

// B2C profile
import B2C_Login from "../../screens/b2c_user/login/login.jsx";
import B2C_RequestResetPasswordToken from "../../screens/b2c_user/request_reset_password_token/request_reset_password_token.jsx";
import ResetPasswordEntry from "../../screens/reset_password_entry/reset_password_entry.jsx";
import MyBmwRentDashboard from "../../screens/b2c_user/my_bmw_rent_dashboard/my_bmw_rent_dashboard.jsx";
import MyBmwRentProfile from "../../screens/b2c_user/my_bmw_rent_profile/my_bmw_rent_profile.jsx";
import MyBmwRentProfileSuccess from "../../screens/b2c_user/my_bmw_rent_profile_success/my_bmw_rent_profile_success.jsx";
import MyBmwRentRentContracts from "../../screens/b2c_user/my_bmw_rent_rent_contracts/my_bmw_rent_rent_contracts.jsx";
import MyBmwRentPaymentMethods from "../../screens/b2c_user/my_bmw_rent_payment_methods/my_bmw_rent_payment_methods.jsx";

// B2B profile
import B2B_Login from "../../screens/b2b_user/login/login.jsx";
import B2B_RequestResetPasswordToken from "../../screens/b2b_user/request_reset_password_token/request_reset_password_token.jsx";
import B2B_Dashboard from "../../screens/b2b_user/dashboard/dashboard.jsx";
import B2B_Profile from "../../screens/b2b_user/profile/profile.jsx";
import B2B_Payment from "../../screens/b2b_user/payment/payment.jsx";
import B2B_History from "../../screens/b2b_user/history/history.jsx";

// Other
import Cms from "../../screens/cms/cms.jsx";

import ErrorOverlay from "../../errors/components/error_overlay.jsx";
import ScreenFlashMessage from "./flash_message.jsx";
import Modal from "./modal";
import * as routes from "../../routing/routes.js";
import AuthRoute from "../../routing/components/route.jsx";
import { removeFlashMessage } from "../actions.js";
import { requiresAuthentication } from "../../routing/util.js";
import { setLoginState } from "../../user/actions.js";
import B2C_SignUp_Guest from "../../screens/b2c_user/sign_up/sign_up_guest.jsx";

const CREATE_RENT_CONTRACT = "FSD0000360";
const UPDATE_RENT_CONTRACT = "FSD0000361";
const SUBMIT_RENT_CONTRACT = "FSD0000363";
const UPDATE_USER_PROFILE = "FSD0000364";
const CANCEL_RENT_CONTRACT = "FSD0000365";
const DELETE_CREDIT_CARD = "FSD0000366";
const SIGN_UP = "FSD0000367";
const EXTEND_SIGN_UP = "FSD0000368";
const LOGIN = "FSD0000369";
const RESET_PASSWORD = "FSD0000370";

export default function AppContent({ onLocationChanged }) {
  const dispatch = useDispatch();
  const locale = useSelector((state) => getCurrentLocale(state));
  const userRole = useSelector((state) => getUserRole(state));

  const rootRoute = userRole === userRoles.B2B
    ? routes.B2B_SelectStationAndTime
    : routes.B2C_SelectStationAndTime;

  const onLocationChangedHandler = useCallback(async (location) => {
    trackPageView(location, { variant: "virtual" });

    dispatch(closeMenu());

    dispatch(removeFlashMessage());

    if (requiresAuthentication(location)) {
      await dispatch(setLoginState());
    }
  }, [dispatch]);

  return (
    <Fragment>
      <Router future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}>
        <RoutesListener onLocationChanged={onLocationChangedHandler} />
        <ScrollToTop />
        <Screen>
          <ScreenHeader />

          <div id={SidebarMenu.outerContainerId}>
            <SidebarMenu />
            <div id={SidebarMenu.pageWrapId} key={locale}>
              <ScreenFlashMessage />
              <Routes>

                <Route path={routes.B2C_Login.path()} element={<B2C_Login />} />
                <Route path={routes.B2C_SignUp.path()} element={<B2C_SignUp />} />
                <Route path={routes.B2C_SignUpGuest.path()} element={<B2C_SignUp_Guest />} />

                <Route path={routes.B2B_Login.path()} element={<B2B_Login />} />
                <Route path={routes.B2B_SignUpRequest.path()} element={<B2B_SignUpRequest />} />

                <Route path={routes.B2C_RequestResetPasswordToken.path()} element={<B2C_RequestResetPasswordToken />} />
                <Route path={routes.B2B_RequestResetPasswordToken.path()} element={<B2B_RequestResetPasswordToken />} />

                <Route path={routes.B2C_LTR_SubmitRentContractSuccess.path()} element={<B2C_LTR_SubmitRentContractSuccess />} />
                <Route path={routes.B2C_STR_SubmitRentContractSuccess.path()} element={<B2C_STR_SubmitRentContractSuccess />} />


                <Route element={<AuthRoute />}>
                  <Route path={routes.B2C_SelectStationAndTime.path()} element={<B2C_SelectStationAndTime />} />
                  <Route path={routes.B2C_SignUpSuccess.path()} element={<B2C_SignUpSuccess />} />
                  <Route path={routes.B2C_ConfirmSignUpEntry.path()} element={<B2C_ConfirmSignUpEntry />} />

                  <Route path={routes.B2C_SignUpConfirmed.path()} element={<B2C_SignUpConfirmed />} />
                  <Route path={routes.B2C_SignUpExtended.path()} element={<B2C_SignUpExtended />} />

                  <Route path={routes.B2B_SelectStationAndTime.path()} element={<B2B_SelectStationAndTime />} />
                  <Route path={routes.B2B_SignUpRequestSuccess.path()} element={<B2B_SignUpRequestSuccess />} />

                  <Route path={routes.B2C_ReservationEntry.path()} element={<B2C_ReservationEntry />} />

                  <Route path={routes.B2C_LTR_SelectRentObject.path()} element={<B2C_LTR_SelectRentObject />} />
                  <Route path={routes.B2C_LTR_SelectExtras.path()} element={<B2C_LTR_SelectExtras />} />
                  <Route path={routes.B2C_LTR_SelectProvisioning.path()} element={<B2C_LTR_SelectProvisioning />} />
                  <Route path={routes.B2C_LTR_SubmitRentContract.path()} element={<B2C_LTR_SubmitRentContract />} />


                  <Route path={routes.B2C_STR_SelectRentObject.path()} element={<B2C_STR_SelectRentObject />} />
                  <Route path={routes.B2C_STR_SelectExtras.path()} element={<B2C_STR_SelectExtras />} />
                  <Route path={routes.B2C_STR_SubmitRentContract.path()} element={<B2C_STR_SubmitRentContract />} />

                  <Route path={routes.B2B_LTR_SelectRentObject.path()} element={<B2B_LTR_SelectRentObject />} />
                  <Route path={routes.B2B_LTR_SelectExtras.path()} element={<B2B_LTR_SelectExtras />} />
                  <Route path={routes.B2B_LTR_SelectExtrasConfirm.path()} element={<B2B_LTR_SelectExtras />} />
                  <Route path={routes.B2B_LTR_SelectDriverAndProvisioning.path()} element={<B2B_LTR_SelectDriverAndProvisioning />} />
                  <Route path={routes.B2B_LTR_SubmitRentContract.path()} element={<B2B_LTR_SubmitRentContract />} />
                  <Route path={routes.B2B_LTR_SubmitRentContractSuccess.path()} element={<B2B_LTR_SubmitRentContractSuccess />} />

                  <Route path={routes.B2B_STR_SelectRentObject.path()} element={<B2B_STR_SelectRentObject />} />
                  <Route path={routes.B2B_STR_SelectExtras.path()} element={<B2B_STR_SelectExtras />} />
                  <Route path={routes.B2B_STR_SelectExtrasConfirm.path()} element={<B2B_STR_SelectExtras />} />
                  <Route path={routes.B2B_STR_SelectDriver.path()} element={<B2B_STR_SelectDriverComponent />} />
                  <Route path={routes.B2B_STR_SubmitRentContract.path()} element={<B2bStrSubmitRentContractComponent />} />
                  <Route path={routes.B2B_STR_SubmitRentContractSuccess.path()} element={<B2B_STR_SubmitRentContractSuccess />} />

                  <Route path={routes.ResetPasswordEntry.path()} element={<ResetPasswordEntry />} />
                  <Route path={routes.MyBmwRentDashboard.path()} element={<MyBmwRentDashboard />} />
                  <Route path={routes.MyBmwRentProfile.path()} element={<MyBmwRentProfile />} />
                  <Route path={routes.MyBmwRentProfileSuccess.path()} element={<MyBmwRentProfileSuccess />} />
                  <Route path={routes.MyBmwRentRentContracts.path()} element={<MyBmwRentRentContracts />} />
                  <Route path={routes.MyBmwRentPaymentMethods.path()} element={<MyBmwRentPaymentMethods />} />


                  <Route path={routes.B2B_Dashboard.path()} element={<B2B_Dashboard />} />
                  <Route path={routes.B2B_Profile.path()} element={<B2B_Profile />} />
                  <Route path={routes.B2B_Payment.path()} element={<B2B_Payment />} />
                  <Route path={routes.B2B_History.path()} element={<B2B_History />} />
                </Route>

                <Route path={routes.Cms.path()} element={<Cms />} />
                <Route path="/" element={<Navigate to={rootRoute.path()} replace />} />
              </Routes>
              <ScreenFooter />
            </div>
          </div>
        </Screen>

        <ErrorOverlay />
        <Modal />
        <FullScreenLoadingIndicator
          blockingActions={{
            "SELECT_RENT_OBJECT/CREATE_RENT_CONTRACT": <T code={CREATE_RENT_CONTRACT} />,
            "SELECT_EXTRAS/UPDATE_RENT_CONTRACT": <T code={UPDATE_RENT_CONTRACT} />,
            "SELECT_PROVISIONING/UPDATE_RENT_CONTRACT": <T code={UPDATE_RENT_CONTRACT} />,
            "RENT_CONTRACTS/SUBMIT_RENT_CONTRACT": <T code={SUBMIT_RENT_CONTRACT} />,
            "USER/UPDATE_PROFILE": <T code={UPDATE_USER_PROFILE} />,
            "HISTORY/CANCEL_RENT_CONTRACT": <T code={CANCEL_RENT_CONTRACT} />,
            "USER/DELETE_CREDIT_CARD": <T code={DELETE_CREDIT_CARD} />,
            "USER/SIGN_UP": <T code={SIGN_UP} />,
            "USER/EXTEND_SIGN_UP": <T code={EXTEND_SIGN_UP} />,
            "USER/LOGIN": <T code={LOGIN} />,
            "USER/RESET_PASSWORD": <T code={RESET_PASSWORD} />
          }} />
      </Router>
    </Fragment>
  );
}
